import Vue from 'vue'
import AscAlertIconCount from '@/components/atoms/AscAlertIconCount'

export default Vue.extend({
  components: {
    AscAlertIconCount,
  },

  data: function () {
    return {}
  },

  computed: {
    getStatus() {
      return this.params.data.status
    },
    getAlertCount() {
      return this.params.data.alertCount
    },
  },

  template: `<asc-alert-icon-count :status="getStatus" style="position:relative; top:-4px" :count="getAlertCount"></asc-alert-icon-count>`,
})
